/**
 * 配置路由
 * 接受如下几种形式
 * (1)'/a/b': 'path/to/module' // 最常用，注意：path/to/module 是相对于 src/modules/ 的路径
 * (2)'/a/c: {component: 'path/to/module', exact: false}  // 增加 exact: false，对路径进行模糊匹配
 * (3)'/a/d': {redirect: '/a/b'}  // 重定向
 */
export const mainRouters = {
  '/': 'home', // 主页
  '/doctors': 'doctors-new', // 专家咨询
  '/doctor-list': 'doctor-list', // 医生列表
  '/doctors/:doctorId': 'doctor-profile', // 医生详情主页
  '/doctors/:doctorId/comments': 'doctor-comment', // 医生服务评价
  '/doctor-apply': 'doctor-apply', // 医生入驻申请落地页
  '/doctor-apply-form': 'doctor-apply-form', // 医生入驻申请信息填写
  '/healthy-channel/doctor-apply': 'doctor-apply-share', // 分享每日科普落地页
  '/doctor-workstation/service-manage': 'doctor-service-manage', // 医生工作台服务管理
  '/doctor-workstation/main-message-manage':
    'doctor-workstation-main-message-manage', // 医生工作台私信管理
  '/doctor-workstation/video-review': 'video-review', // 医生作品众裁页面
  '/doctor-workstation/video-review/long-pictures-preview':
    'long-pictures-preview', // 作品众裁的长图查看页面
  '/doctor-workstation/video-review/pictures-set-preview':
    'pictures-set-preview', // 作品众裁的图集查看页面
  '/doctor-workstation/video-review/rule': 'video-review-rule', // 作品众裁规则页面
  '/doctor-visit-info': 'doctor-visit-info', // 医生出诊信息

  '/patients/': 'patients', // 患者列表页
  '/patients/add': 'patient-info', // 添加患者表单页
  '/patients/edit/:patientId': 'patient-info', // 修改患者表单页
  '/order/create/:doctorId/:productType': 'order-create', // 创建订单表单页
  // `/order/register-create/${doctorHospitalId}?hospitalIndexId=${selectedHospitalId}&hospitalDepartmentId=${selectedDepartmentId}&hospitalDoctorId=${doctorHospitalId}&selectedDateId=${selectedDateId}&selectedTimeId=${value.id}`
  '/order/register-create/:doctorHospitalId': 'register-create', // 创建挂号订单页
  '/order/records': 'order-records', // 咨询订单列表页
  '/order/doctor-records': 'order-records', // 医生咨询订单列表页
  '/order/detail/:orderId': 'order-detail', // 用户图文/电话咨询订单详情页
  '/order/register-detail/:orderId': 'register-order-detail', // 用户挂号订单详情页
  '/order/doctor-detail/:orderId': 'doctor-order-detail', // 医生订单详情页
  '/order/comment': 'comment', // 订单评价页
  '/order/refund': 'order-refund', // 退款申请
  '/order/refund/:orderId': 'refund-detail', // 退款进展
  // '/contact/:type/:userId': 'home',
  '/hospitals': 'hospitals',
  // '/hospitals/:hospitalId': 'home',
  '/inquiry': 'inquiry',
  '/baike': 'baike',
  '/baike/:videosId': 'series',
  '/vaccination': 'vaccination',
  '/topic/:topicId': 'topic',
  '/topics': 'topics',
  '/lives': 'lives',
  '/order/pay': 'order-pay', // 下单信息
  '/order/profit': 'order-profit', // 医生-收入明细
  '/service-order': 'service-order',
  '/covid-19/testing': 'covid-19-testing',
  '/covid-19/store/:storeId': 'covid-19-goods',
  '/order/covid-19': 'covid-19-order',
  '/order/covid-19/:orderId': 'covid-19-order-detail',
  '/order/covid-19/:storeId/create': 'covid-19-order-create',
  '/order/covid-19/:orderId/booking': 'booking',
  '/order': 'order',
  '/covid-19/patients': 'covid-19-patients',
  '/covid-19/patients/add': 'covid-19-patient-info',
  '/covid-19/patients/edit/:patientId': 'covid-19-patient-info',
  '/order/covid-19/:orderId/refund-apply': 'covid-19-refund-apply', // 退款申请
  '/order/covid-19/:orderId/refund-detail': 'covid-19-refund-detail', // 退款进展
  '/covid-19/activity': 'covid-19-activity',
  '/author-weekly/:uniqueId/:doctorId': 'author-weekly',
  '/author-weekly': 'author-weekly',
  '/auth-content': 'auth-xiaoyu',
  '/a-test': 'a-test',
  '/user-satisfaction-survey': 'user-satisfaction-survey',
  // '/a-confirm-payment': 'a-confirm-payment', // 挂号线上支付后静态页test使用,后期不用可以删掉
  '/lib-test': 'lib-component-test',
  '/doctor-workstation': 'workstation',
  '/doctor-profile/:doctorId': 'doctor-workstation-profile', // 医生工作台-我的
  '/setting': 'setting', // 通知
  '/setting/push': 'setting-push', // 推送
  '/about': 'about',
  '/dev-diy': 'dev-diy',
  '/daily-baike': 'daily-baike',

  // 山大二院挂号入口白名单域名 - 某个医院所有科室页
  '/healthy-channel/register/hospital/:hospitalIndexId': 'register-hospital',

  // 这里有个匹配的顺序问题，如果把/experts的路由放到/:hospitalIndexId路由后面
  // 页面路径为/experts时，会先被当成hospitalIndexId参数处理
  // 挂号 - 某个医院的挂号医生详细介绍页面
  '/register/hospital/experts': 'register-hospital-experts',
  // 挂号 - 所有 - 某个医院所有一级、二级科室页
  '/register/hospital/:hospitalIndexId': 'register-hospital',

  // 挂号 - 某个医院的信息详情页
  '/register/hospital/detail/:hospitalIndexId': 'register-hospital-detail',
  // 挂号 - 某个医院的就医指南页面
  '/register/hospital/guide/:hospitalIndexId': 'register-hospital-guide',
  // 挂号 - 某个医院的预约咨询页面
  '/register/hospital/appointment/:hospitalIndexId':
    'register-hospital-appointment',
  // 挂号 - 健康之路 - 所有医院某科室医生列表页
  '/register/v2/departments/': 'register-department',
  // 挂号 - 健康之路 - 某医院某科室医生列表页
  '/register/v2/department/:hospitalIndexId/:secondDepartmentId':
    'register-department',
  // 挂号 - 山大二院 - 某二级科室医生列表页
  '/register/department/:hospitalIndexId/:secondDepartmentId':
    'register-department',
  // 挂号 - 医生详情主页，没有快手ID的医生
  '/register/doctors/:hospitalDoctorId': 'doctor-profile',
  // 挂号 - v1.2 - 首页
  '/register/home': 'register-home',
  // 挂号 - v1.2 - 按医院搜索
  '/register/search/hospital': 'register-search-hospital',
  // 挂号 - v1.2 - 按科室搜索
  '/register/search/department': 'register-search-department',
  // 挂号 - 未获得定位权限的fallback页面
  '/register/fallback': 'register-fallback',

  '/daily-baike-share': 'daily-baike-share',
  '/healthy-channel': 'home', // 分享首页落地页
  '/healthy-channel/daily-baike-share': 'daily-baike-share', // 分享每日科普落地页

  '/quick-consult/create': 'quick-consult-create',
  '/order/quick-consult': 'quick-consult',
  '/order/quick-consult/:orderId': 'quick-consult-detail',

  '/agreements': 'agreements',
  '/survey/list/': 'survey-list', // 健康量表自测列表页
  '/survey/list/:departmentId': 'survey-list', // 健康量表自测列表页
  '/survey/detail/:surveyCode': 'survey-detail', // 健康量表自测详情页
  '/survey/question/:surveyCode': 'survey-question', // 健康量表自测答题页
  '/survey/report/:surveyCode': 'survey-report', // 健康量表自测报告页
  '/survey/records': 'survey-records', // 健康自测历史答题记录列表页
  '/survey/record/:id': 'survey-record-detail', // 健康自测历史答题记录详情页

  '/healthy-channel/skin-detection': 'skin-detection', // 拍照测肤分享落地页
  '/skin-detection': 'skin-detection', // 拍照测肤落地页,
  '/skin-detection/upload-image': 'skin-upload-image', // 拍照测肤上传图片
  '/skin-detection/user-info': 'skin-detection-user-info', // 拍照测肤检测人信息
  '/skin-detection/report': 'skin-detection-report', // 拍照测肤检测报告
  '/skin-detection/questions': 'skin-detection-questions-collect', // 拍照护肤健康自测问题

  '/med/outsite/:encodeUrl': 'med-outsite', // 公共 - 跳转外站中转页
  '/med/detail/:drugId/:merchantShopSkuId/:source': 'med-detail', // 公共 - 药品详情

  '/med/shop/select/:id': 'med-shop-select', // 用户端 - 药房选择页
  '/med/shop/select/otc/:id': 'med-shop-select', // 用户端 - 商品推荐药房选择页
  '/med/addr/list': 'med-addr-list', // 用户端 - 收货地址列表页
  '/med/addr/add': 'med-addr-edit', // 用户端 - 收货地址添加页
  '/med/addr/edit/:medAddrId/:medProvinceCode/:medCityCode/:medCountyCode':
    'med-addr-edit', // 用户端 - 收货地址编辑页
  '/med/user/cart/:adviseId': 'med-user-cart', // 用户端 - 购物车

  '/med/doctor/shop/select/:orderId': 'med-doctor-shop-select', // 医生端 - 选择药店
  '/med/doctor/kuai/:orderId': 'med-doctor-kuai', // 医生端 - 快手小店商品选择
  '/med/doctor/advise/:orderId': 'med-doctor-advise', // 医生端 - 商品建议单
  '/med/doctor/advise/detail/:adviseId': 'med-doctor-advise-detail', // 医生端 - 商品建议查看
  '/med/doctor/search/:drugType': 'med-doctor-search', // 医生端 - 药品搜索
  '/med/doctor/cooperation-doctors': 'med-doctor-cooperation-doctors', // 医生端 - 合作医生
  '/med/doctor/prescribe-doctors': 'med-doctor-prescribe-doctors', // 医生端 - 开方医师

  '/prescription/preview/:id': 'prescription-preview', // 医生 - 处方预览
  '/prescription/create/:orderId': 'prescription-create', // 医生 - 新增处方
  '/prescription/update/:orderId/:prescriptionId': 'prescription-create', // 医生 - 修改处方
  '/prescription/create/:orderId/:prescriptionId': 'prescription-create', // 医生 - 修改处方
  '/prescription/detail/:prescriptionId': 'prescription-detail', // 公共 - 处方详情

  '/disease/history/info/:orderId': 'disease-history-info', // 病史信息
  '/clinical/diagnosis': 'clinical-diagnosis', // 临床诊断
  '/method/drug/use/:drugId': 'method-drug-use', // 用法用量
  '/feedback/help-feedback': 'feedback-help-feedback', // 客服-帮助与反馈
  '/feedback/question-detail/:questionId': 'feedback-question-detail', // 客服-问题详情
  '/feedback/suggestion-feedback': 'feedback-suggestion-feedback', // 客服-意见反馈

  '/andrology-center': 'andrology-center', // 男科中心落地页

  '/dermatological-center': 'dermatological-center', // 皮科中心落地页
  '/dermatological-center/dermatological-answer-detail/:unique':
    'dermatological-answer-detail', // 热门话题详情页
  '/dermatological-center-share': 'dermatological-center-share', // 分享皮科中心/男科中心落地页/临时皮科活动详页
  '/healthy-channel/dermatological-center-share': 'dermatological-center-share', // 站外白名单域名匹配路由

  '/coupon-list': 'coupon/coupon-list', // 优惠券列表
  '/coupon-selection/:doctorId/:orderPrice/:productType':
    'coupon/coupon-selection', // 优惠券选择列表列表
  '/coupon-landing': 'coupon/coupon-landing-page', // 优惠券活动落地页
  '/healthy-channel/coupon-landing': 'coupon/coupon-landing-page', // 优惠券活动分享落地页

  // 临时活动 皮科活动
  '/dermatological-activity': 'dermatological-activity', // 皮科活动详情页面

  // 医生私信引导健康咨询服务
  '/msg-app-guidance': 'msg-app-guidance', // 站内私信页面中的链接
  '/consult-info-collect': 'consult-info-collect', // 咨询信息搜集
  '/icon-demo': 'icon-demo',

  // 患者数据完善 诊疗小结
  '/consult/doctor/summary/create/:orderId': 'consult-summary/doctor-summary', // 医生 - 新增咨询小结
  '/consult/doctor/summary/update/:orderId/:summaryId':
    'consult-summary/doctor-summary', // 医生 - 更新咨询小结
  '/consult/summary/detail/:orderId': 'consult-summary/summary-detail', // 咨询小结详情页

  '/doctor-workstation-message': 'doctor-workstation-message', // 医生工作台消息
  '/doctor-videos-select': 'doctor-videos-select', // 选择医生作品页面

  '/main-message': 'main-message', // 站内私信页面中的链接

  '/med-dictionary': 'med-dictionary', // 健康医典页面
  '/med-dictionary-search': 'med-dictionary-search',

  '/download/video': 'download-video' // iOS用 下载落地页
};

export default mainRouters;
